import type { SlideProps } from "@/engine/app/offsite-config";

export function Slide30Danke(_: SlideProps) {
  return (
    <div className="deck-root dark slide-manifesto" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />
      <div
        className="float"
        aria-hidden="true"
        style={{
          width: 420,
          height: 420,
          top: "-120px",
          right: "-100px",
          background: "var(--svo-blau)",
          opacity: 0.30,
        }}
      />
      <div
        className="float"
        aria-hidden="true"
        style={{
          width: 320,
          height: 320,
          bottom: "-100px",
          left: "10%",
          background: "var(--svo-gruen)",
          opacity: 0.12,
          animationDelay: "4s",
        }}
      />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Danke</div>
        <h1
          className="deck-title rise rise-2"
          style={{
            fontSize: "clamp(5rem, 13vw, 11rem)",
            fontWeight: 200,
            color: "var(--svo-blau)",
            lineHeight: 0.95,
            letterSpacing: "-0.04em",
          }}
        >
          Danke!
        </h1>
        <p className="deck-sub rise rise-3" style={{ fontStyle: "italic" }}>
          Fragen, Kaffee, oder beides.
        </p>
      </header>

      <div className="deck-lead">
        <div className="lead-body rise rise-4" style={{ color: "var(--svo-weiss)", fontWeight: 500 }}>
          Viktor Lüders
        </div>
        <div className="lead-body rise rise-5" style={{ color: "rgba(255,255,255,0.7)" }}>
          IT Requirements Manager · SVO Vertrieb GmbH
        </div>
      </div>

      <footer className="deck-foot">
        <span>SVO Vertrieb GmbH · Celle · Uelzen</span>
      </footer>
    </div>
  );
}
